export default {
  DRAFT:     'draft',
  READY:     'ready',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  EXPIRED:   'expired',
};
